import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { PolicyType, AppClaimType } from 'types/user.interface';
import { checkClaims } from 'util/user.utility';

@Directive({
  selector: '[appPermission]',
  standalone: true
})
export class ClaimDirective implements OnInit {
  @Input() policyType!: PolicyType;
  @Input() claimType!: AppClaimType;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    if (!checkClaims(this.policyType, this.claimType)) {
      this.el.nativeElement.remove();
    }
  }
}
